import React, { useEffect, useState } from "react";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Popper,
  Button,
  Paper,
  OutlinedInput,
  Divider,
  Typography,
  ClickAwayListener,
} from "@mui/material";
import { ArrowDropDown, ArrowDropUp, Search } from "@mui/icons-material";
import { gql, useMutation } from "@apollo/client";
import { UPDATE_EVENT, addCompanyHourGroup } from "../../graphql/mutations";

const EventTypesPopper = ({
  events,
  preData,
  group,
  user,
  groupData,
  setUpdating,
  customRefetch,
  eventRefetch,
  tab,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [open, setOpen] = useState(false);
  const [selectedEvents, setSelectedEvents] = useState(
    events.filter((val) => val.groupId == group).map((val) => val.id)
  );
  const [search, setSearch] = useState("");
  const [changed, setChanged] = useState(
    events.filter((val) => val.groupId == group).map((val) => val.id)
  );
  const handleClick = (event) => {
    event.stopPropagation();
    setOpen(!open);
  };

  const handleClose = (event) => {
    setOpen(false);
  };
  useEffect(() => {
    setSelectedEvents(
      events.filter((val) => val.groupId == group).map((val) => val.id)
    );
    setChanged(
      events.filter((val) => val.groupId == group).map((val) => val.id)
    );
  }, [group, open]);

  const handleSelectAll = () => {
    setSelectedEvents(events.map((event) => event.id));
  };

  const handleDeselectAll = () => {
    setSelectedEvents([]);
  };

  const handleCheckboxChange = (event) => {
    const { value, checked } = event.target;
    if (checked) {
      setSelectedEvents([...selectedEvents, value]);
    } else {
      setSelectedEvents(selectedEvents.filter((id) => id !== value));
    }
  };

  const anchorRef = React.useRef(null);
  const [updateEvent] = useMutation(UPDATE_EVENT);
  const handleSubmit = (props) => {
    updateEvent({ variables: props })
      .then((res) => {
        console.log(res);
        eventRefetch();
        customRefetch();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleCreateCustomGroup = (props) => {
    addCompanyHourGroups({
      variables: {
        input: [
          {
            userId: user.userId,
            custom: true,
            def: false,
            title: "My custom hour group",
          },
        ],
      },
    })
      .then((res) => {
        handleSubmit({
          groupId: parseInt(res.data.addCompanyHourGroup.id),
          eventId: parseInt(props.eventId),
        });
        eventRefetch();
        customRefetch();
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const [addCompanyHourGroups] = useMutation(addCompanyHourGroup);
  const handleSave = () => {
    setUpdating(true);
    const newlySelected = selectedEvents.filter(
      (event) => !changed.includes(event)
    );
    const newlyDeselected = changed.filter(
      (event) => !selectedEvents.includes(event)
    );
    newlySelected.map((eventId) => {
      handleSubmit({
        groupId: parseInt(group),
        eventId: parseInt(eventId),
      });
    });
    newlyDeselected.map((eventId) => {
      handleCreateCustomGroup({
        groupId: parseInt(group),
        eventId: parseInt(eventId),
      });
    });
    setOpen(false);
  };
  useEffect(() => {
    setOpen(false);
  }, [groupData, tab]);
  return (
    <div>
      <Button ref={anchorRef} onClick={handleClick}>
        {events.filter((val) => val.groupId == group).length} Event Types{" "}
        {open ? <ArrowDropUp /> : <ArrowDropDown />}
      </Button>
      <Popper
        open={open}
        anchorEl={anchorRef.current}
        style={{ zIndex: 5, paddingTop: "10px" }}
        placement="bottom-start"
      >
        <Paper
          style={{ width: "356px" }}
          sx={{
            boxShadow: 3,
          }}
        >
          <div style={{ padding: "10px" }}>
            <OutlinedInput
              value={search}
              onChange={(event) => setSearch(event.target.value)}
              placeholder="Search..."
              fullWidth
              style={{ height: "50px", borderRadius: "10px" }}
            />
          </div>
          <Divider />
          <div
            className="displayFlex"
            style={{ padding: "5px", justifyContent: "space-between" }}
          >
            <Button onClick={handleSelectAll}>Select All</Button>
            <Button onClick={handleDeselectAll}>Deselect All</Button>
          </div>
          <Divider />
          <div
            className="displayFlex column"
            style={{ padding: "20px", height: "404px", gap: "20px" }}
          >
            <div
              style={{
                display:
                  events?.filter(
                    (val) =>
                      val?.groupId == group &&
                      val?.name?.toLowerCase()?.includes(search)
                  )?.length == 0 && "none",
              }}
            >
              <h1 className="font2">ACTIVE ON</h1>
              <FormControl component="fieldset">
                <FormGroup>
                  {events
                    .filter(
                      (val) =>
                        val?.groupId == group &&
                        val?.name?.toLowerCase().includes(search)
                    )
                    .map((event) => (
                      <FormControlLabel
                        key={event.id}
                        control={
                          <Checkbox
                            checked={selectedEvents.includes(event.id)}
                            onChange={handleCheckboxChange}
                            value={event.id}
                          />
                        }
                        label={event.name}
                      />
                    ))}
                </FormGroup>
              </FormControl>
            </div>
            <div
              style={{
                display:
                  events.filter(
                    (val) =>
                      val?.groupId != group &&
                      val?.name?.toLowerCase()?.includes(search)
                  )?.length == 0 && "none",
              }}
            >
              <h1 className="font2" style={{ padding: "5px 0" }}>
                {user.username.toUpperCase()}
              </h1>
              <FormControl component="fieldset">
                <FormGroup>
                  {events
                    .filter(
                      (val) =>
                        val?.groupId != group &&
                        val?.name?.toLowerCase().includes(search)
                    )
                    .map((event) => (
                      <div className="displayFlex column">
                        <FormControlLabel
                          key={event.id}
                          control={
                            <Checkbox
                              checked={selectedEvents.includes(event.id)}
                              onChange={handleCheckboxChange}
                              value={event.id}
                            />
                          }
                          label={
                            event.name +
                            " - " +
                            (preData.find((val) => val.id == event.groupId)
                              ?.custom
                              ? "Custom Hours"
                              : preData.find((val) => val.id == event.groupId)
                                  .title)
                          }
                        />
                        <h4
                          className="font"
                          style={{
                            marginLeft: "27px",
                            display:
                              !preData.find((val) => val.id == event.groupId)
                                ?.custom && "none",
                          }}
                        >
                          Custom
                        </h4>
                      </div>
                    ))}
                </FormGroup>
              </FormControl>
            </div>
          </div>
          <Divider />
          <div
            className="displayFlex"
            style={{ padding: "10px", justifyContent: "space-between" }}
          >
            <Button onClick={() => setOpen(false)}>Close</Button>
            <Button
              onClick={handleSave}
              variant="contained"
              style={{ background: "#d9bca9" }}
            >
              Save
            </Button>
          </div>
        </Paper>
      </Popper>
    </div>
  );
};

export default EventTypesPopper;
